import { render, staticRenderFns } from "./LogoutHospitalPopup.vue?vue&type=template&id=503a572a&"
import script from "./LogoutHospitalPopup.vue?vue&type=script&lang=js&"
export * from "./LogoutHospitalPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports